// export const green = "#46d993";
export const green = "#C73336";
export const customWhite="#FFFFFF";
export const lightText = "#5e5e5e";
export const customBlue="#122243";
